import React, { useState } from 'react';

const BankingTab = ({ couple, onSave }) => {
  const [bankingData, setBankingData] = useState({
    arsComplete: !!(couple.accountInfoARS?.cbu),
    usdComplete: !!(couple.accountInfoUSD?.cbu),
    mpComplete: false,
  });

  return (
    <form onSubmit={onSave} className="space-y-6 animate-fade-in max-w-4xl mx-auto">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-display font-bold text-neutral-900">
          Datos Bancarios
        </h2>
        <span className="text-sm text-neutral-600">
          Configurá las cuentas donde recibirás los regalos
        </span>
      </div>

      {/* Mercado Pago */}
      <div className="card p-6 space-y-4 mt-6">
  <div className="flex items-center justify-between">
    <h3 className="text-xl font-display font-semibold text-neutral-900 flex items-center gap-2">
      <span>💳</span> Mercado Pago
    </h3>

    {bankingData.mpComplete ? (
      <span className="text-green-600 text-sm font-semibold">✓ Configurada</span>
    ) : (
      <span className="text-neutral-500 text-sm font-semibold">Opcional</span>
    )}
  </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
          <p className="text-sm text-blue-800">
            Si querés que tus invitados puedan enviarte dinero por Mercado Pago, ingresá tu CVU o Alias.
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-neutral-700 mb-2">
            CVU de Mercado Pago
          </label>
          <input
            type="text"
            name="mercadoPagoCVU"
            defaultValue={couple.mercadoPago?.cvu || ''}
            placeholder="0000003100012345678901"
            className="input-field font-mono"
            maxLength="22"
            minLength="22"
            pattern="[0-9]{22}"
          />
          <p className="text-xs text-neutral-500 mt-1">
            Tu CVU tiene exactamente 22 dígitos numéricos. Lo encontrás en la app de Mercado Pago.
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-neutral-700 mb-2">
            Alias de Mercado Pago
          </label>
          <input
            type="text"
            name="mercadoPagoAlias"
            defaultValue={couple.mercadoPago?.alias || ''}
            placeholder="maria.boda.mp"
            className="input-field"
            maxLength="50"
            pattern="[a-z0-9.]+"
          />
          <p className="text-xs text-neutral-500 mt-1">
            Tu alias personalizado de Mercado Pago (solo minúsculas, números y puntos)
          </p>
        </div>
      </div>

      {/* ARS Account */}
      <div className="card p-6 space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="text-xl font-display font-semibold text-neutral-900 flex items-center gap-2">
            <span>🇦🇷</span> Cuenta en Pesos (ARS)
          </h3>
          {bankingData.arsComplete ? (
            <span className="text-green-600 text-sm font-semibold">✓ Configurada</span>
          ) : (
            <span className="text-yellow-600 text-sm font-semibold">⚠️ Recomendado</span>
          )}
        </div>

        <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-4 mb-4">
          <p className="text-sm text-neutral-700">
            Los regalos en pesos argentinos se depositarán en esta cuenta.
          </p>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-neutral-700 mb-2">
              Alias
            </label>
            <input
              type="text"
              name="arsAlias"
              defaultValue={couple.accountInfoARS?.alias || ''}
              placeholder="maria.juan.boda"
              className="input-field"
              maxLength="50"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-neutral-700 mb-2">
              CBU
            </label>
            <input
              type="text"
              name="arsCbu"
              defaultValue={couple.accountInfoARS?.cbu || ''}
              placeholder="0000003100010000000000"
              className="input-field font-mono"
              maxLength="22"
              minLength="22"
              pattern="[0-9]{22}"
            />
            <p className="text-xs text-neutral-500 mt-1">
              El CBU tiene exactamente 22 dígitos numéricos
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-neutral-700 mb-2">
              Titular de la Cuenta
            </label>
            <input
              type="text"
              name="arsAccountHolder"
              defaultValue={couple.accountInfoARS?.accountHolder || ''}
              placeholder="María González / Juan Pérez"
              className="input-field"
              maxLength="100"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-neutral-700 mb-2">
              Banco
            </label>
            <input
              type="text"
              name="arsBank"
              defaultValue={couple.accountInfoARS?.bank || ''}
              placeholder="Ej: Banco Galicia"
              className="input-field"
              maxLength="50"
            />
          </div>
        </div>
      </div>

      {/* USD Account */}
      <div className="card p-6 space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="text-xl font-display font-semibold text-neutral-900 flex items-center gap-2">
            <span>💵</span> Cuenta en Dólares (USD)
          </h3>
          {bankingData.usdComplete ? (
            <span className="text-green-600 text-sm font-semibold">✓ Configurada</span>
          ) : (
            <span className="text-neutral-500 text-sm font-semibold">Opcional</span>
          )}
        </div>

        <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-4 mb-4">
          <p className="text-sm text-neutral-700">
            Opcional. Solo necesario si querés recibir regalos en dólares desde el exterior o PayPal.
          </p>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-neutral-700 mb-2">
              Alias
            </label>
            <input
              type="text"
              name="usdAlias"
              defaultValue={couple.accountInfoUSD?.alias || ''}
              placeholder="maria.juan.usd"
              className="input-field"
              maxLength="50"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-neutral-700 mb-2">
              CBU
            </label>
            <input
              type="text"
              name="usdCbu"
              defaultValue={couple.accountInfoUSD?.cbu || ''}
              placeholder="0000003100010000000000"
              className="input-field font-mono"
              maxLength="22"
              minLength="22"
              pattern="[0-9]{22}"
            />
            <p className="text-xs text-neutral-500 mt-1">
              El CBU tiene exactamente 22 dígitos numéricos
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-neutral-700 mb-2">
              Titular de la Cuenta
            </label>
            <input
              type="text"
              name="usdAccountHolder"
              defaultValue={couple.accountInfoUSD?.accountHolder || ''}
              placeholder="María González / Juan Pérez"
              className="input-field"
              maxLength="100"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-neutral-700 mb-2">
              Banco
            </label>
            <input
              type="text"
              name="usdBank"
              defaultValue={couple.accountInfoUSD?.bank || ''}
              placeholder="Ej: Banco Galicia"
              className="input-field"
              maxLength="50"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-neutral-700 mb-2">
              Email de PayPal (opcional)
            </label>
            <input
              type="email"
              name="usdPaypalEmail"
              defaultValue={couple.accountInfoUSD?.paypalEmail || ''}
              placeholder="tu@email.com"
              className="input-field"
            />
            <p className="text-xs text-neutral-500 mt-1">
              Debe ser un email válido
            </p>
          </div>
        </div>
      </div>

      {/* Payment Methods Preferences */}
      <div className="bg-white border border-neutral-200 rounded-2xl p-6 shadow-sm">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
            <span className="text-xl">⚙️</span>
          </div>
          <h3 className="text-xl font-display font-semibold text-neutral-900">
            Métodos de Pago Habilitados
          </h3>
        </div>

        <p className="text-sm text-neutral-600 mb-4">
          Seleccioná qué métodos de pago querés mostrar a tus invitados en el checkout.
        </p>

        <div className="space-y-3">
          {/* Transferencia ARS */}
          <label className="flex items-center justify-between p-4 rounded-xl border border-neutral-200 hover:bg-neutral-50 cursor-pointer transition-colors">
            <div className="flex items-center gap-3">
              <div className="text-2xl">🏦</div>
              <div>
                <p className="font-semibold text-neutral-900">Transferencia en Pesos (ARS)</p>
                <p className="text-xs text-neutral-500">
                  {couple.accountInfoARS?.cbu || couple.accountInfoARS?.alias ? '✓ Configurado' : '⚠ Sin configurar'}
                </p>
              </div>
            </div>
            <input
              type="checkbox"
              name="enableTransferARS"
              defaultChecked={couple.paymentMethods?.transferARS !== false}
              className="w-5 h-5 rounded accent-accent-500"
            />
          </label>

          {/* Transferencia USD */}
          <label className="flex items-center justify-between p-4 rounded-xl border border-neutral-200 hover:bg-neutral-50 cursor-pointer transition-colors">
            <div className="flex items-center gap-3">
              <div className="text-2xl">💵</div>
              <div>
                <p className="font-semibold text-neutral-900">Transferencia en Dólares (USD)</p>
                <p className="text-xs text-neutral-500">
                  {couple.accountInfoUSD?.cbu || couple.accountInfoUSD?.alias ? '✓ Configurado' : '⚠ Sin configurar'}
                </p>
              </div>
            </div>
            <input
              type="checkbox"
              name="enableTransferUSD"
              defaultChecked={couple.paymentMethods?.transferUSD !== false}
              className="w-5 h-5 rounded accent-accent-500"
            />
          </label>

          {/* Mercado Pago */}
          <label className="flex items-center justify-between p-4 rounded-xl border border-neutral-200 hover:bg-neutral-50 cursor-pointer transition-colors">
            <div className="flex items-center gap-3">
              <div className="text-2xl">💳</div>
              <div>
                <p className="font-semibold text-neutral-900">Mercado Pago</p>
                <p className="text-xs text-neutral-500">
                  {couple.mercadoPago?.alias || couple.mercadoPago?.cvu ? '✓ Configurado' : '⚠ Sin configurar'}
                </p>
              </div>
            </div>
            <input
              type="checkbox"
              name="enableMercadoPago"
              defaultChecked={couple.paymentMethods?.mercadoPago !== false}
              className="w-5 h-5 rounded accent-accent-500"
            />
          </label>

          {/* PayPal */}
          <label className="flex items-center justify-between p-4 rounded-xl border border-neutral-200 hover:bg-neutral-50 cursor-pointer transition-colors">
            <div className="flex items-center gap-3">
              <div className="text-2xl">🌐</div>
              <div>
                <p className="font-semibold text-neutral-900">PayPal</p>
                <p className="text-xs text-neutral-500">
                  {couple.accountInfoUSD?.paypalEmail ? '✓ Configurado' : '⚠ Sin configurar'}
                </p>
              </div>
            </div>
            <input
              type="checkbox"
              name="enablePayPal"
              defaultChecked={couple.paymentMethods?.paypal !== false}
              className="w-5 h-5 rounded accent-accent-500"
            />
          </label>

          {/* Efectivo */}
          <label className="flex items-center justify-between p-4 rounded-xl border border-neutral-200 hover:bg-neutral-50 cursor-pointer transition-colors">
            <div className="flex items-center gap-3">
              <div className="text-2xl">💵</div>
              <div>
                <p className="font-semibold text-neutral-900">Efectivo</p>
                <p className="text-xs text-neutral-500">No requiere configuración</p>
              </div>
            </div>
            <input
              type="checkbox"
              name="enableEfectivo"
              defaultChecked={couple.paymentMethods?.efectivo !== false}
              className="w-5 h-5 rounded accent-accent-500"
            />
          </label>
        </div>

        <div className="mt-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
          <p className="text-xs text-blue-800">
            💡 <strong>Tip:</strong> Activá solo los métodos que tengas configurados para evitar confusión a tus invitados.
          </p>
        </div>
      </div>

      {/* Save Button */}
      <button
        type="submit"
        className="btn-primary w-full text-base py-3 sm:py-3"
      >
        Guardar datos bancarios
      </button>
    </form>
  );
};

export default BankingTab;